<template>

	<div class="row">

		<div class="col-md-12">

			<div class="table-responsive">

				<table class="table table-hover table-striped">

					<thead>
						<tr>
							<th v-translate>Aluno (turma)</th>
							<th v-translate>Assunto</th>
							<th v-translate>Participantes</th>
							<th class="text-right" v-translate>Data de envio</th>
						</tr>
					</thead>

					<tbody>

						<router-link tag="tr" :to="{ path: `/inbox/reply-message/${ message.messageGroup }` } " :key="message.messageGroup" v-for="message in sentMessages" :class="{ 'active': message.notRead === 0, 'bold': message.notRead === 1 }">

							<td class="view-message align-middle hidden-xs">
								{{ message.student.name }}<br>
								<small v-if="message.student.schoolClass && message.student.schoolClass.description">
									Turma: {{ message.student.schoolClass.description }}
								</small>
							</td>
							<td class="view-message align-middle">{{ message.subject }}</td>
							<td class="view-message align-middle">{{ message.members }}</td>
							<td class="view-message align-middle text-right">
								{{ message.dateTime | date('DD/MM/YYYY HH:mm') }}
							</td>

						</router-link>

					</tbody>

					<tfoot v-if="sentMessages.length === 0">
						<tr>
							<td colspan="4" class="text-center" v-translate>
								Nenhuma mensagem enviada
							</td>
						</tr>
					</tfoot>

				</table>

			</div>

		</div>

		<div class="col-md-12 text-right">

			<pagination v-if="sentMessages.length > 0" layout="prev, next" @current-change="handleCurrentChange"></pagination>

		</div>

	</div>

</template>

<script>

	import SentMessages from './';
	export default SentMessages;

</script>



// WEBPACK FOOTER //
// list.vue?42551a8d